import { component } from 'picoapp'
import Slider from '~/lib/slider'
import $ from 'quantdom'

export default component((node) => {
  const scrollTrack = $(node).find('[data-scroll-track]').el()
  const buttonPrevious = $(node).find('button.js-previous-arrow')
  const buttonNext = $(node).find('button.js-next-arrow')
  const startSlide = $(node).find('[data-start-slide]').el()?.dataset?.startSlide
  const title = $(node).attr('data-slider-title')

  const slider = new Slider({ el: scrollTrack }, ({ isMin, isMax, index }) => {
    buttonPrevious.attr('aria-disabled', isMin)
    buttonNext.attr('aria-disabled', isMax)

    if (isMax && isMin) {
      buttonPrevious.attr('aria-disabled', false)
      buttonNext.attr('aria-disabled', false)
      slider.slideTo(index, 'auto')
    }
  })

  setTimeout(() => {
    if (startSlide) {
      slider.slideTo(startSlide, 'auto')
    }
  }, 2000)

  buttonPrevious.on('click', () => {
    slider.slideLeft()
    if (window?.gtag) {
      window.gtag('event', 'Slider Back', {
        event_detail: title,
      })
    }
  })

  buttonNext.on('click', () => {
    slider.slideRight()
    if (window?.gtag) {
      window.gtag('event', 'Slider Advance', {
        event_detail: title,
      })
    }
  })
})
